import { Object3D } from '@seddi/three';

/**
 * Create 3D object.
 * @param id - Unique ID.
 * @param parent - Parent 3D object.
 */
export const create = (id: string, parent?: Object3D): Object3D => {
  const node = new Object3D();
  node.name = id;
  parent?.add(node);
  return node;
};

/**
 * Remove from parent.
 * @param self - 3D object.
 */
export const removeFromParent = (self: Object3D) => {
  if (!self.parent) {
    return;
  }
  self.parent.remove(self);
};

/**
 * Reset transform.
 * @param self - 3D object.
 */
export const resetTransform = (self: Object3D) => {
  self.position.set(0, 0, 0);
  self.rotation.set(0, 0, 0);
  self.scale.set(1, 1, 1);
  self.updateMatrix();
};
